import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Artigo } from '../classes/artigo';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ArtigoService {
  private endpoint = environment.urlAPI + '/artigo';

  constructor(private http: HttpClient) {}

  getArtigo(resumo: string, contabilizar: boolean) {
    return this.http.post<Artigo>(
      this.endpoint,
      JSON.stringify({ resumo: resumo, contabilizar: contabilizar }),
    );
  }
}
